import { BsFillTrashFill } from "react-icons/bs";

export function DeleteButton({
  title = "Eliminar",
  onClick,
  type = "button",
  size = "md",
}) {
  return (
    <button
      type={type}
      className={`btn btn-${size} btn-outline-danger`}
      onClick={onClick}
    >
      <span>{title}</span>
      <BsFillTrashFill className="ms-1" />
    </button>
  );
}
